<div class="rd-widget widget-{{widgetConfig.widgetId}} widget-text-container widgetText rd-widget-no-height-restriction {{widgetGuid}}" *ngIf="widgetData" [class.editMode]="editMode">
  <table aria-hidden="true" [class.iframeEditor]="editMode && useIframe" [class.headerMode]="rdStorage.appWidgetHeaderMode$ | async">
    <tr *ngIf="useIframe && !rdStorage.getAppPrintMode() && editMode">
      <td style="vertical-align: top" class="textWidget-td useIframe gridster-item-content">

        <kendo-editor #iframeEditor [iframe]="true" style="height: 100%; width: 100%;" [preserveWhitespace]="'full'"
                      [(ngModel)]="textWidgetText"
                      [iframeCss]="{ path: './assets/text-widget/textWidgetEditor.css' }"
                      (valueChange)="valueChange($event)"
                      (focus)="onFocus()"
                      (blur)="onBlur()"
                      (paste)="onPaste($event)"
                      hashtag
                      [page]="page"
                      [widget]="this"
                      [kendoEditorValue]="textWidgetText"
                      [selectedTag]="hashTag"
                      [editMode]="editMode"
                      (setNewValue)="setNewValue($event);"
                      id="textWidgetEditor-{{currentLayout}}"
                      [elType]="'kendo'">
          <kendo-toolbar [overflow]="true">
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
          </kendo-toolbar>
        </kendo-editor>
      </td>
    </tr>

    <tr *ngIf="!useIframe && !rdStorage.getAppPrintMode() && editMode">
      <td style="vertical-align: top" class="textWidget-td inline gridster-item-content">

        <kendo-editor #inlineEditor [iframe]="false" style="display: inline-block; overflow: hidden; height: 100%; width: 100%;" [preserveWhitespace]="'full'"
                      [(ngModel)]="textWidgetText"
                      class="inline-editor"
                      (valueChange)="valueChange($event)"
                      (focus)="onFocus()"
                      (blur)="onBlur()"
                      (paste)="onPaste($event)"
                      hashtag
                      [page]="page"
                      [widget]="this"
                      [kendoEditorValue]="textWidgetText"
                      [selectedTag]="hashTag" [widgetId]="this.widgetConfig.widgetId"
                      [editMode]="editMode"
                      (setNewValue)="setNewValue($event);"
                      id="textWidgetEditor-{{currentLayout}}"
                      [elType]="'kendo'">
        </kendo-editor>
      </td>
    </tr>

    <tr *ngIf="!editMode">
      <td style="vertical-align: top" class="textWidget-td">
        <div class="textWidget-Preview" hashtagsetvalue [widget]="this" [page]="page" style="width:100%;" [innerHtml]="previewContent | trustedHtml"></div>
      </td>
    </tr>

  </table>
</div>
